<script>
  import 'bootstrap-css-only/css/bootstrap.min.css'
  import 'mdbvue/build/css/mdb.css'
  import 'vue-snotify/styles/material.css'
  import { mdbContainer } from 'mdbvue'
  export default {
    data: () => ({
    }),
    computed: {
      isUserLogged () {
        return this.$store.getters['user/IS_LOGGED']
      }
    },
    components: {
      mdbContainer,
      AppHeader: () => import('@/components/layout/header/AppHeader'),
      LoginPage: () => import('@/views/Login.vue')
    }
  }
</script>


<template>
  <div id="app">
    <AppHeader />
    <main class="mt-5 pt-5">
      <mdb-container fluid v-if="isUserLogged">
        <router-view />
      </mdb-container>
      <LoginPage v-else />
      <vue-snotify></vue-snotify>
    </main>
  </div>
</template>

<style lang="scss">
  // @import 'reset-css';
  @import 'sass/setup/variables.scss';
  @import 'sass/common.scss';
  // * {
  //   box-sizing: border-box;
  // }
  html {
    height: 100%;
  }
  body {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'Roboto', sans-serif;
  }
  #app {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
  }
  main {
    display: flex;
    flex-direction: column;
    &,
    & > .container-fluid {
      flex: 1 0 auto;
    }
  }
  // strong {
  //   font-weight: bold;
  // }
  // .app {
  //   display: flex;
  //   flex-direction: column;
  //   flex: 1 0 auto;
  //   &__header {
  //     display: flex;
  //     justify-content: space-between;
  //     align-items: center;
  //     height: 60px;
  //     padding: 0 $sidePadding;
  //     background: #fff;
  //   }
  //   &__main {
  //     flex: 1 1 auto;
  //     display: flex;
  //     flex-direction: column;
  //   }
  //   &__foter {
  //   }
  // }
</style>
